var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper col-xs-3 col-md-3 m-b-15"},[_c('div',{staticClass:"widget-15 panel no-border bg-success no-margin widget-loader-bar"},[_c('h3',{staticClass:"no-margin p-b-5 text-white"},[_vm._v(_vm._s(this.qty))]),_vm._v(" "),_c('span',{staticClass:"fs-13 text-white"},[_vm._v("Clients domiciliés")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57d496d8","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Dashboard/Stats/DomiciliedCustomers.vue
// module id = 1875
// module chunks = 0